// Components
export * from './components/register-an-account/register-an-account.component';
export * from './components/customer-details-partial/customer-details-partial.component';
export * from './components/order-info-partial/order-info-partial.component';
export * from './components/receipt-header-partial/receipt-header-partial.component';
export * from './components/remember-partial/remember-partial.component';
export * from './components/return-info-partial/return-info-partial.component';

// Module
export * from './receipt.module';
